import {
    EzObject,
    EzNumber,
    EzString
} from '/ezlibrary/helpers/EzHelpers.js';

import { EzSpinnerConstants } from '/public/webcomponents/spinner/EzSpinnerConstants.js';

/**
 * @class
 * @description
 * Information object for active spinners
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with:
 *  import { EzActiveSpinnerInfo } from '/public/webcomponents/spinner/EzActiveSpinnerInfo.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzActiveSpinnerInfo {
    /**
     * @private @field
     * Stores the active spinner's id
     *
     * @type {string}
     */
    #spinnerId = EzSpinnerConstants.GENERIC_SPINNER_ID;
    /**
     * @public @property @getter
     * Gets the active spinner's id
     *
     * @returns {string}
     */
    get spinnerId() {
        return this.#spinnerId;
    }
    /**
     * @public @property @gsetter
     * Sets the active spinner's id
     *
     * @param {undefined|null|string} spinnerId
     * Default: EzSpinnerConstants.GENERIC_SPINNER_ID
     */
    set spinnerId(spinnerId = EzSpinnerConstants.GENERIC_SPINNER_ID) {
        this.#spinnerId = EzString.stringWithLengthOrDefault(
            spinnerId,
            EzSpinnerConstants.GENERIC_SPINNER_ID);
    }

    /**
     * @private @field
     * Stores the active spinner's options
     *
     * @type {string}
     */
    #options = EzSpinnerConstants.DEFAULT_SPINNER_OPTIONS;
    /**
     * @public @property @getter
     * Gets the active spinner's options
     *
     * @returns {string}
     */
    get options() {
        return this.#options;
    }
    /**
     * @public @property @gsetter
     * Sets the active spinner's options
     *
     * @param {undefined|null|string} options
     * Default: EzSpinnerConstants.DEFAULT_SPINNER_OPTIONS
     */
    set options(options = EzSpinnerConstants.DEFAULT_SPINNER_OPTIONS) {
        this.#options = EzObject.assignOrDefault(
            options,
            EzSpinnerConstants.DEFAULT_SPINNER_OPTIONS);
    }

    /**
     * @private @field
     * Stores the active spinners 'active' count (number of calls to show spinner without closing)
     *
     * @type {string}
     */
    #activeCount = EzNumber.ONE;
    /**
     * @public @property @getter
     * Gets the active spinners 'active' count (number of calls to show spinner without closing)
     *
     * @returns {string}
     */
    get activeCount() {
        return this.#activeCount;
    }
    /**
     * @public @property @gsetter
     * Sets the active spinners 'active' count (number of calls to show spinner without closing)
     *
     * @param {undefined|null|string} activeCount
     * Default: EzNumber.ONE
     */
    set activeCount(activeCount = EzNumber.ONE) {
        this.#spinnerId = EzNumber.numberOrDefault(
            activeCount,
            EzNumber.ONE);
    }
}
